import React from 'react';

/** Logo character colors: green #32613D for A,D,H,D; red #8F2A2A for (,r,x,) */
const LOGO_CHARS = [
  { char: 'A', color: 'text-logo-green' },
  { char: '(', color: 'text-logo-red' },
  { char: 'r', color: 'text-logo-red' },
  { char: 'D', color: 'text-logo-green' },
  { char: 'x', color: 'text-logo-red' },
  { char: ')', color: 'text-logo-red' },
  { char: 'H', color: 'text-logo-green' },
  { char: 'D', color: 'text-logo-green' },
] as const;

const LOGO_CHARS_LIGHT = [
  { char: 'A', color: 'text-logo-green-light' },
  { char: '(', color: 'text-logo-red-light' },
  { char: 'r', color: 'text-logo-red-light' },
  { char: 'D', color: 'text-logo-green-light' },
  { char: 'x', color: 'text-logo-red-light' },
  { char: ')', color: 'text-logo-red-light' },
  { char: 'H', color: 'text-logo-green-light' },
  { char: 'D', color: 'text-logo-green-light' },
] as const;

export type LogoVariant = 'default' | 'light';

export interface LogoProps {
  variant?: LogoVariant;
  className?: string;
  /** Optional suffix after the logo, e.g. " Games" */
  suffix?: string;
}

export const Logo: React.FC<LogoProps> = ({
  variant = 'default',
  className = '',
  suffix = '',
}) => {
  const chars = variant === 'light' ? LOGO_CHARS_LIGHT : LOGO_CHARS;
  return (
    <span
      className={`font-logo font-bold tracking-tight ${className}`}
      style={{ fontFamily: 'Nunito, system-ui, sans-serif' }}
    >
      {chars.map(({ char, color }, i) => (
        <span key={i} className={color}>
          {char}
        </span>
      ))}
      {suffix}
    </span>
  );
};

export default Logo;
